import { render, staticRenderFns } from "./ExtraButton.vue?vue&type=template&id=35443e07&scoped=true&lang=pug&"
import script from "./ExtraButton.vue?vue&type=script&lang=js&"
export * from "./ExtraButton.vue?vue&type=script&lang=js&"
import style0 from "./ExtraButton.vue?vue&type=style&index=0&id=35443e07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35443e07",
  null
  
)

export default component.exports